"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const FarmListController_1 = __importDefault(require("../modules/controllers/FarmListController"));
const PreQuoteModal_vue_1 = __importDefault(require("@becrop/components/ClientFarmListView/components/PreQuoteModal.vue"));
const CRUDModal_vue_1 = __importDefault(require("@becrop/components/ClientFarmListView/components/CRUDModal.vue"));
const RequestQuoteSplit_vue_1 = __importDefault(require("@becrop/components/ClientFarmListView/components/RequestQuoteSplit.vue"));
const floating_vue_1 = require("floating-vue");
const eBeCropIcon_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/StatusTags/eBeCropIcon.vue"));
let FarmTable = class FarmTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.CONTROLLER = FarmListController_1.default.getInstance();
        this.rowFarmSelected = null;
        this.loadingView = false;
        this.loadingResult = false;
        this.ixSelected = -1;
        this.isPreQuoteModalActive = false;
        this.isCRUDModalActive = false;
        this.CRUDState = 'remove';
        this.removingFarm = false;
        this.removedFarmFeedback = '';
        this.removedFarmFeedbackMessage = [];
        this.loading = false;
    }
    async updateStyleRows() {
        this.rowFarmSelected = null;
        if (this.farms.length > 0) {
            await this.selectFarm(this.farms[0]);
        }
    }
    async mounted() {
        this.loadingView = false;
        if (this.farms.length > 0) {
            await this.selectFarm(this.farms[0]);
        }
    }
    async selectFarm(farm) {
        this.loading = true;
        this.rowFarmSelected = farm;
        await farm.fetchFieldsGeodata();
        this.drawFarmInMap(farm);
        this.loading = false;
    }
    drawFarmInMap(farm) {
        this.$emit('drawFarmInMap', farm);
    }
    goMap(farm) {
        this.loadingView = true;
        setTimeout(() => {
            window.location.href = `/last_result?farm_list=true&farm_id=${farm.id}`;
        }, 1500);
        this.loadingView = false;
    }
    goResultInMap(farm) {
        this.loadingResult = true;
        setTimeout(() => {
            window.location.href = `/results/map?projectId=${farm.last_completed_project.project_id}&areaId=${farm.gis_area_id}`;
        }, 1500);
        this.loadingResult = false;
    }
    async downloadFarmPDF(farm) {
        await farm.downloadPDF();
    }
    editFarm(farm) {
        window.location.href = `/farm/${farm.id}/edit`;
    }
    newConfig(farm) {
        window.location.href = `/farm/${farm.id}/edit?newConfig=true`;
    }
    dismissAndReload() {
        this.dismissCRUDModal();
        this.drawFarmInMap(this.farms[this.ixSelected]);
    }
    async removeFarm() {
        try {
            this.removingFarm = true;
            this.removedFarmFeedback = '';
            this.removedFarmFeedbackMessage = [];
            this.ixSelected = this.farms.findIndex((f) => f.id === this.rowFarmSelected.id);
            const resp = await this.CONTROLLER.removeFarm(this.rowFarmSelected);
            this.CRUDState = 'feedback';
            if (resp.status === 200) {
                this.removedFarmFeedback = 'ok';
                this.removedFarmFeedbackMessage.push('Farm Removed!');
            }
            else {
                this.removedFarmFeedback = 'error';
                this.removedFarmFeedbackMessage = [...resp.messages];
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.removingFarm = false;
        }
    }
    requestFarmRemoval(farm) {
        this.rowFarmSelected = farm;
        this.CRUDState = 'remove';
        this.deployCRUDModal();
    }
    requestQuote(farm) {
        this.selectFarm(farm);
        this.deployPreQuoteModal();
    }
    deployPreQuoteModal() {
        this.isPreQuoteModalActive = true;
    }
    dismissPreQuoteModal() {
        this.isPreQuoteModalActive = false;
    }
    updateFarmDetails(farmDetails) {
        if (!farmDetails ||
            typeof farmDetails.details.farmDetails.has_gis_area_assigned !== 'boolean' ||
            typeof farmDetails.details.farmDetails.has_results !== 'boolean') {
            console.warn('Invalid farmDetails: ', farmDetails);
            return;
        }
        const farmId = farmDetails.farmId;
        const farm = this.farms.find((f) => f.id === farmId);
        if (!farm) {
            console.warn(`Farm with id ${farmId} not found`);
            return;
        }
        farm.has_gis_area_assigned = farmDetails.details.farmDetails.has_gis_area_assigned;
        farm.has_results = farmDetails.details.farmDetails.has_results;
        farm.quote_status = farmDetails.details.quoteStatus;
    }
    deployCRUDModal() {
        this.isCRUDModalActive = true;
    }
    dismissCRUDModal() {
        this.isCRUDModalActive = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FarmTable.prototype, "farms", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FarmTable.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('farms')
], FarmTable.prototype, "updateStyleRows", null);
FarmTable = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { TableBmk: bmk_ui_framework_1.TableBmk, TableHeader: bmk_ui_framework_1.TableHeader, TableHeaderCell: bmk_ui_framework_1.TableHeaderCell, TableBody: bmk_ui_framework_1.TableBody, TableBodyRow: bmk_ui_framework_1.TableBodyRow, TableBodyCell: bmk_ui_framework_1.TableBodyCell, CodeSnippet: bmk_ui_framework_1.CodeSnippet, Button: bmk_ui_framework_1.Button, ArrowUpRight: lucide_vue_next_1.ArrowUpRight, PreQuoteModal: PreQuoteModal_vue_1.default, Dropdown: floating_vue_1.Dropdown, eBeCropIcon: eBeCropIcon_vue_1.default, Pencil: lucide_vue_next_1.Pencil, Trash2: lucide_vue_next_1.Trash2, CRUDModal: CRUDModal_vue_1.default, RequestQuoteSplit: RequestQuoteSplit_vue_1.default, Loading: bmk_ui_framework_1.Loading, Download: lucide_vue_next_1.Download } })
], FarmTable);
exports.default = FarmTable;
